/** sessionStorage key for invite token across Cognito Hosted UI / social OAuth redirects. */
export const PENDING_INVITATION_TOKEN_KEY = 'pendingInvitationToken';
